import React from 'react';
import classNames, { Argument } from 'classnames';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import { useSelector } from 'hooks';

import { arePreApprovedPricesHidden, getCurrencyIsoCode } from 'modules/selfServices/selectors';

type TotalLineProps = {
  title: React.ReactNode,
  price: number,
  showHiddenPriceWarning?: boolean,
  className?: Argument
};

const TotalLine: React.FC<TotalLineProps> = (
  { title, price, showHiddenPriceWarning, className },
) => {
  const currencyIsoCode = useSelector(getCurrencyIsoCode);
  const hidePreApprovedWorksPrices = useSelector(arePreApprovedPricesHidden);

  const showWarning = showHiddenPriceWarning && hidePreApprovedWorksPrices;

  return (
    <div className={classNames('flex justify-between items-center text-lowest text-xs font-medium pl-2', className)}>
      <div>{title}</div>
      {showWarning && <FormattedMessage id="basket.total.toBeConfirmed" defaultMessage="To be confirmed" />}
      {!showWarning && (
        <FormattedNumber value={price} style="currency" currency={currencyIsoCode} />
      )}
    </div>
  );
};

export default TotalLine;
